import React, { useState } from "react";

import {
  PrimaryButton,
  SecondaryButton,
  SingleSelect,
  Text,
} from "widgets";
import Loader from "Shared/Loader/Loader";
import {
  useOrderCancelReasons,
  useRequestCancelOrder,
} from "store/backend/assets";
import { useSnackbarContext } from "widgets/SnackBar/SnackBar";

import styles from "./CancelOrder.module.scss";

const handleCancelOrderReasonChange = (event, setSelectedReason) => {
  setSelectedReason(event.target.value);
};

const handleSubmitCancellationReason = (
  selectedReason,
  orderId,
  requestCancelOrder,
  onClose,
  openSnackbar
) => {
  if (!selectedReason) {
    return;
  }

  const payload = {
    order_id: orderId,
    reason_id: selectedReason,
  };

  requestCancelOrder(payload, {
    onSuccess: () => {
      openSnackbar("Order cancellation requested successfully.", "success");
      onClose();
      window.location.reload();
    },
    onError: (error) => {
      openSnackbar(` ${error.message || "Please try again later."}`, "error");
    },
  });
};

const CancelOrder = (props) => {
  const { onClose, orderId } = props;
  const { openSnackbar } = useSnackbarContext();
  const [selectedReason, setSelectedReason] = useState(null);
  const {
    mutate: requestCancelOrder,
    isPending: isRequestCancelOrderPending,
  } = useRequestCancelOrder();
  const {
    isPending: isReasonsLoading,
    data: reasons,
    error: reasonError,
  } = useOrderCancelReasons();


  if (reasonError) {
    return <span>Error fetching Cancellation Reasons</span>;
  }

  return (
    <div className={styles.popOverContainer}>
      <Text>Please Select Reason for Cancellation</Text>
      <div className={styles.dropdownContainer}>
        {isReasonsLoading ? (
          <div className={styles.loaderContainer}>
            <Loader />
          </div>
        ) : (
          <SingleSelect
            tag="Select a Reason"
            name="Order Cancel Reason"
            value={selectedReason ?? ""}
            handleChange={(event) =>
              handleCancelOrderReasonChange(event, setSelectedReason)
            }
            menuItems={reasons ?? []}
          />
        )}
      </div>
      <div className={styles.flexContainer}>
        <SecondaryButton onClick={onClose}>Go Back</SecondaryButton>
        <PrimaryButton
          onClick={() =>
            handleSubmitCancellationReason(
              selectedReason,
              orderId,
              requestCancelOrder,
              onClose,
              openSnackbar
            )
          }
          disabled={!selectedReason || isRequestCancelOrderPending}
        >
          {isRequestCancelOrderPending ? "Submitting..." : "Submit"}
        </PrimaryButton>
      </div>
    </div>
  );
};

export default CancelOrder;
